import React, { Component } from 'react'
import './style.css'
import './navbar.css'
import './media.css'
import Main from './component/Main'

export default class App extends Component {
  render() {
    return (
      <Main />
    )
  }
}
